import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const BubbleBath = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="bubble-bath"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M30 27.182c-1.213 0-3.838.026-6.943.206V16.903a5.353 5.353 0 00-5.349-5.346c-.92 0-1.774.255-2.532.666a7.846 7.846 0 012.209 2.732c.11-.018.21-.065.323-.065 1.11 0 2.015.903 2.015 2.013v2.643l-4.028.646v-1.83a5.352 5.352 0 00-5.346-5.347A5.354 5.354 0 005 18.362v3.125a1.668 1.668 0 003.334 0v-3.125c0-1.11.905-2.013 2.015-2.013s2.013.903 2.013 2.013V28.7C8.213 29.607 5 31.053 5 33.362c0 5.883 20.827 6.18 25 6.18 4.176 0 25-.297 25-6.18s-20.824-6.18-25-6.18zm-14.305-3.613l4.028-.648v4.713a75.518 75.518 0 00-4.028.468v-4.534zM30 36.172c-13.698 0-20.224-1.258-20.224-2.81 0-1.551 6.644-2.81 20.224-2.81 13.81 0 20.223 1.259 20.223 2.81 0 1.552-7.124 2.81-20.223 2.81z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 37c-20 0-25-4-25-4v14c0 3.866 11.193 7 25 7s25-3.134 25-7V33s-5 4-25 4zM40.5 15a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0-3.75c.21 0 .53.065.791.253.248.178.459.479.459.997h.5c0-.681-.29-1.132-.666-1.403a1.925 1.925 0 00-1.084-.347v.5zM32 22a2 2 0 100-4 2 2 0 000 4zm0-2.95c.16 0 .406.05.604.193.185.134.346.359.346.757h.5c0-.561-.24-.936-.554-1.163A1.59 1.59 0 0032 18.55v.5zM39 28a2 2 0 100-4 2 2 0 000 4zm0-2.95c.16 0 .406.05.604.193.185.134.346.359.346.757h.5c0-.561-.24-.936-.554-1.163A1.59 1.59 0 0039 24.55v.5zM35 8a2 2 0 100-4 2 2 0 000 4zm0-2.95c.16 0 .406.05.604.193.185.134.346.358.346.757h.5c0-.561-.24-.937-.554-1.163A1.59 1.59 0 0035 4.55v.5z"
      />
    </svg>
  );
};
/* eslint-enable max-len */

BubbleBath.defaultProps = {
  className: null,
};

BubbleBath.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default BubbleBath;
